import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { ACCENT_HEX, GREY_HEX, WHITE_HEX } from '../../../constants';
const RFErrorNodeFC = ({ nodeId, templateCode, elementType, selected }) => {
    const { t } = useT();
    console.info(`Unknown template "${templateCode}" for ${elementType} ${nodeId}`);
    return (_jsx(Flex, { width: "100px", height: "100px", borderRadius: "4px", border: "1px solid", fontWeight: "600", fontSize: "11px", borderColor: selected ? ACCENT_HEX : GREY_HEX, alignItems: "center", textAlign: "center", bg: WHITE_HEX, children: _jsx("span", { children: t('rfFields.common.unknownTemplateOf', { type: elementType }) }) }));
};
export const RFErrorNode = RFErrorNodeFC;
//# sourceMappingURL=RFErrorNode.js.map